import type React from "react";
import { ReactComponent as Svg } from "./assets/deposits.svg";
import * as styles from "./Icon.module.scss";

type DepositsProps = React.SVGProps<SVGSVGElement>;

export const Deposits = ({ className, ...props }: DepositsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
